import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-traspasos',
  templateUrl: './traspasos.component.html',
  styleUrls: []
})
export class TraspasosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
